enum MutationType {
  SET_CURRENT_USER = "user/SET_CURRENT_USER",
}

export default MutationType;
